import { createRouter, createWebHashHistory,createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/customization',
    name: 'customization',
    component: () => import('../views/Customization.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/platform',
    name: 'platform',
    component: () => import('../views/Platform.vue')
  },
  
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 实际滚动容器是 .wrap（overflow-y:auto），切换路由后手动回到顶部
router.afterEach(() => {
  const wrap = document.querySelector('.wrap') as HTMLElement | null
  if (wrap) {
    wrap.scrollTop = 0
  }
})

export default router
